var map = {
	"./PaellaCoreLayouts.js": 4493,
	"./es.upv.paella.dualVideo.js": 7236,
	"./es.upv.paella.dualVideoDynamic.js": 675,
	"./es.upv.paella.dualVideoPiP.js": 6593,
	"./es.upv.paella.singleVideo.js": 8785,
	"./es.upv.paella.singleVideoDynamic.js": 6126,
	"./es.upv.paella.tripleVideo.js": 2128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4803;